// example : <OrderOnCallButton onClick={somefunction} type={insert-type-here} text="hello" />
// type 1 green button, type 2 cancel button, default white button
import React from 'react';
import PropTypes from 'prop-types';

require('./OrderOnCallButton.scss');

const OrderOnCallButton = ({
  onClickFunction,
  type,
  text,
  loading,
  tabIndex,
  disabled,
}) => {
  const getBtnClass = ({ type }) => {
    if (type === 1) {
      return 'commonBtn proceedBtn';
    } else if (type === 2) {
      return 'commonBtn cancelBtn';
    } else if (type === 3){
      return 'commonBtn serviceBtn';
    } else {
      return 'commonBtn defaultBtn';
    }
  };

  const handleOnClick = () => {
    onClickFunction();
  }

  return (
    <button
      tabIndex={ tabIndex ? tabIndex : ''}
      onClick={handleOnClick}
      className={getBtnClass({ type })}
      disabled={disabled}
    >
      {loading ? 'Loading...' : text}
    </button>
  );
};

OrderOnCallButton.propTypes = {
  onClickFunction: PropTypes.func.isRequired,
  type: PropTypes.number,
  text: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

OrderOnCallButton.defaultProps = {
  type: 0,
  text: '',
  loading: false,
  disabled: false,
};

export default OrderOnCallButton;
